// extracted by mini-css-extract-plugin
export var container = "pagination-module--container--hmeBx";
export var currentSelection = "pagination-module--current-selection--JglMH";